import { QueryCache } from 'react-query';

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      ...(process.env?.NODE_ENV === 'development' ? { retry: 0, refetchOnWindowFocus: false } : {}),
      initialStale: true,
      queryFnParamsFilter: args => args.slice(1),
    },
  },
});

export default queryCache
